import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { Input } from 'semantic-ui-react';

const CollectionFieldInput = ({
  autoFocus,
  text,
  type,
  maxLength,
  icon,
  iconPosition,
  size,
  onChange,
  className,
}) => {
  const intl = useIntl();
  return (
    <Input
      fluid
      autoFocus={autoFocus}
      icon={icon}
      iconPosition={iconPosition}
      size={size}
      className={clsx('aridhia-collection-field-input primary aridhia-is-edit-mode', className)}
      value={text || ''}
      maxLength={maxLength}
      placeholder={intl.formatMessage({ id: `collection.${type}.placeholder` })}
      onChange={(e, { value }) => { onChange(value); }}
    />
  );
};

export default CollectionFieldInput;
